import axios from "../services/api/api";
import {
  FETCH_INVOICE_HISTORY_BEGIN,
  FETCH_INVOICE_HISTORY_FULFILLED,
  FETCH_INVOICE_HISTORY_REJECTED
} from "../reducers/invoiceHistoryReducer";

export function fetchInvoiceHistory(email) {
  return function(dispatch) {
    dispatch({ type: FETCH_INVOICE_HISTORY_BEGIN });
    axios
      .get("/Shop/MyOrders")
      .then(response => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_FULFILLED,
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_REJECTED,
          payload: err
        });
      });
  };
}

// TODO när tid finnes: Låt användaren välja år genom att istället kalla på Shop/GetSpecificYear(int offsetFromCurrentYear)
//  0 ger nuvarande räkenskapsår
// -1 ger föregående räkenskapsår
// -2 ger 2019-07-01 - 2020-06-30 etc etc
//  OBS att /Shop/GetAll numera ger nuvarande räkenskapsår
export function fetchInvoiceHistoryForAllCustomers() {
  return function(dispatch) {
    dispatch({ type: FETCH_INVOICE_HISTORY_BEGIN });
    axios
      .get("/Shop/GetAll")  
      .then(response => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_FULFILLED,
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_REJECTED,
          payload: err
        });
      });
  };
}
